import { create } from 'zustand';

const useCartStore = create((set, get) => ({
  items: [],
  isCartOpen: false,

  addItem: (product) => {
    if (product.available === false) return;
    const items = get().items;
    const existing = items.find(i => i.id === product.id);
    if (existing) {
      set({ items: items.map(i => i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i) });
    } else {
      set({ items: [...items, { ...product, quantity: 1 }] });
    }
  },

  removeItem: (productId) => {
    set({ items: get().items.filter(i => i.id !== productId) });
  },

  updateQuantity: (productId, quantity) => {
    if (quantity <= 0) {
      set({ items: get().items.filter(i => i.id !== productId) });
    } else {
      set({ items: get().items.map(i => i.id === productId ? { ...i, quantity } : i) });
    }
  },

  clearCart: () => set({ items: [] }),
  toggleCart: () => set({ isCartOpen: !get().isCartOpen }),
  openCart: () => set({ isCartOpen: true }),
  closeCart: () => set({ isCartOpen: false }),

  get totalItems() { return get().items.reduce((sum, i) => sum + i.quantity, 0); },
  get totalPrice() { return get().items.reduce((sum, i) => sum + (parseFloat(i.price) * i.quantity), 0); },
}));

export default useCartStore;
